import { useState, useEffect, useCallback } from 'react'
import { authHeaders } from '../utils/authFetch'

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080'

export function useCustomerAnalyticsData() {
    const [customers, setCustomers] = useState([])
    const [orders, setOrders] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const fetchAll = useCallback(async () => {
        try {
            setError(null)
            const res = await fetch(`${API_BASE_URL}/api/customer-analytics/data`, { headers: authHeaders() })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error || 'Failed to load customer data')

            setCustomers(data.customers || [])
            setOrders(data.orders || [])
        } catch (err) {
            console.error('Error fetching customer analytics data:', err)
            setError(err.message)
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        fetchAll()
    }, [fetchAll])

    return { customers, orders, loading, error, refetch: fetchAll }
}